export const paginationOptions = {
  perPageOptions: [10, 20, 30, 40, 50, 100],
  perPageRows: 20,
  defaultPerPage: 1,
};

export const APP_LINKS = {
  lots: process.env.REACT_APP_LOTS_URL || 'https://lots.teamsignal.com/',
  set: process.env.REACT_APP_SET_URL || 'https://sales.teamsignal.com/',
  edge: process.env.REACT_APP_EDGE_URL || 'https://portal.teamsignal.com/',
  ticketingSystem:
    process.env.REACT_APP_TICKETING_SYSTEM_URL || 'https://support.teamsignal.com/tickets-view',
  signalIntranet:
    process.env.REACT_APP_SIGNAL_INTRANET_URL ||
    'https://s88fg.sharepoint.com/sites/SignalHub/SitePages/Home.aspx?e=1:534afab8d10044ad8bb957261755566c',
};

export const actionItemTypeKeys = {
  zone: 'zone',
  franchise: 'franchise',
  site: 'site',
};

export const dashboardOptions = {
  dashboard: 'Dashboard',
};

export const supportedImageFormats = ['image/jpeg', 'image/jpg', 'image/png'];

export const pdfFileFormats = ['application/pdf'];

export const videoFileFormats = [
  'video/mp4',
  'video/mpeg',
  'video/avi',
  'video/mov',
  'video/quicktime',
];

export const allowedImageExtensions = ['.png, .jpg, .jpeg, .svg'];

export const maxFileSize = 25 * 1024 * 1024;

export const DEFAULT_TIMEZONE = 'America/New_York';

export const rolesEnum = {
  homeOfficer: 'home_officer',
  franchiseOwner: 'franchise_owner',
  director: 'director',
  salesManger: 'sales_manager',
  coordinator: 'coordinator',
  supervisor: 'supervisor',
  officer: 'officer',
  advanced_officer: 'advanced_officer',
};

export const rolesEnumWithName = {
  home_officer: { slug: 'home_officer', name: 'Home Office Admin' },
  franchise_owner: { slug: 'franchise_owner', name: 'Franchise Owner' },
  director: { slug: 'director', name: 'Director' },
  sales_manager: { slug: 'sales_manager', name: 'Sales Manager' },
  coordinator: { slug: 'coordinator', name: 'Coordinator' },
  supervisor: { slug: 'supervisor', name: 'Supervisor' },
  officer: { slug: 'officer', name: 'Officer' },
  advanced_officer: { slug: 'advanced_officer', name: 'Advanced Officer' },
};

/**
 * Toast message settings
 */
export const toastSettings = {
  AUTO_CLOSE: 3000,
};

/**
 * default avatar
 */

export const defaultImage = `https://signalassets.blob.core.windows.net/signal/assets/Avatar.svg`;
export const defaultVehicleImage = `https://signalassets.blob.core.windows.net/signal/assets/vehicle-default.svg`;
export const defaultMapZoom = 10;

export const daysOfWeekWithVal = [
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
  { label: 'Sunday', value: 0 },
];

export const MAX_3_DIGIT_VALUE = 999;
export const MAX_4_DIGIT_VALUE = 9999;
export const MAX_5_DIGIT_VALUE = 99999;

export const enumResponseType = {
  text: 0,
  number: 1,
  multiselect: 2,
  datetime: 3,
  radio: 4,
  date: 5,
  imageVideo: 6,
  time: 7,
  dropdown: 8,
  attachments: 9,
  webCam: 10,
  description: 11,
  phone: 12,
};

export const enumDynamicForm = {
  dynamicFormField: 'dynamicFormField',
};

export const franchiseIdUrlQueryParam = 'franchiseId';
export const franchiseTimeZone = 'tz';

export const timeZoneKeyUrlQueryParam = 'tz';

export const franchiseIdSource = {
  url: 'url',
  redux: 'redux',
};

export const NO_LOT_ID = 'no-lot';
